import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteInterestMutation } from '../../../../../../redux/services/fj_interests.jsx';
import {
  dataGridDateSorter,
  dataGridTextSorter,
} from '../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import { QuestionModal } from '../../../../../common/index.jsx';
import PropTypes from 'prop-types';
import DataGrid from '../../../../../common/DataGrid/DataGrid.jsx';
import {
  FileSearchOutlined,
  EyeOutlined,
  DeliveredProcedureOutlined,
} from '@ant-design/icons';
import { IconButton } from '../../../../../common/controls/Controls.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';

const FjMyInterestsTable = ({
  studentsInterest,
  refetch,
  onEditClick,
  onDetailClick,
}) => {
  const { t } = useTranslation();
  const { successMessage } = useToastMessages();
  const navigate = useNavigate();

  const [deleteInterest, { isSuccess }] = useDeleteInterestMutation();
  const [rowToBeDeleted, setRowToBeDeleted] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      successMessage({
        message: 'Boli ste odhlásený z pracovnej ponuky',
      });
      refetch();
    }
  }, [isSuccess]);

  const customSettings = (interest) => {
    return (
      <div style={{ display: 'flex' }}>
        {/*<IconButton*/}
        {/*  icon={<UserDeleteOutlined />}*/}
        {/*  tooltip={t('Zrušiť záujem')}*/}
        {/*  onClick={e => {*/}
        {/*    e.stopPropagation();*/}
        {/*    setRowToBeDeleted(interest.id);*/}
        {/*  }}*/}
        {/*/>*/}

        <IconButton
          icon={<DeliveredProcedureOutlined />}
          tooltip={t('Zobraziť detail záujmu')}
          onClick={(e) => {
            e.stopPropagation();
            navigate(`${routes.cmsFriJobsInterestDetail}/${interest.id}`);
          }}
        />

        <IconButton
          icon={<FileSearchOutlined />}
          tooltip={t('Zobraziť detail pracovnej ponuky')}
          onClick={(e) => {
            e.stopPropagation();
            onDetailClick(interest);
          }}
        />
      </div>
    );
  };

  // Table Definition
  const jobTitleTextFilterProps = useDataGridTextFilter('job_title');
  const placeOfWorkTextFilterProps = useDataGridTextFilter('job_place_of_work');
  const salaryTextFilterProps = useDataGridTextFilter('job_salary');
  const dateOfStartTextFilterProps = useDataGridTextFilter('job_date_of_start');
  const dateOfApplicationTextFilterProps =
    useDataGridDateRangeFilter('created_at');
  const partnerNameTextFilterProps = useDataGridTextFilter('job_partner_name');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Externý partner FRI'),
        dataIndex: 'job_partner_name',
        sorter: dataGridTextSorter('job_partner_name'),
        ...partnerNameTextFilterProps,
      },
      {
        title: t('Názov pracovnej ponuky'),
        dataIndex: 'job_title',
        ellipsis: true,
        sorter: dataGridTextSorter('job_title'),
        ...jobTitleTextFilterProps,
      },
      {
        title: t('Miesto'),
        dataIndex: 'job_place_of_work',
        ellipsis: true,
        sorter: dataGridTextSorter('job_place_of_work'),
        ...placeOfWorkTextFilterProps,
      },
      {
        title: t('Plat'),
        dataIndex: 'job_salary',
        ellipsis: true,
        sorter: dataGridTextSorter('job_salary'),
        ...salaryTextFilterProps,
      },
      {
        title: t('Voľná od'),
        dataIndex: 'job_date_of_start',
        ellipsis: true,
        sorter: dataGridTextSorter('job_date_of_start'),
        ...dateOfStartTextFilterProps,
      },
      {
        title: t('Dátum prihlásenia'),
        dataIndex: 'created_at',
        ellipsis: true,
        sorter: dataGridDateSorter('created_at'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...dateOfApplicationTextFilterProps,
      },
    ],
    [t],
  );

  return (
    <>
      <DataGrid
        rowKey={(interest) => interest.id}
        columns={dataGridColumns}
        onEditClick={onEditClick}
        onRowClick={onDetailClick}
        onRowDetailClick={onDetailClick}
        dataSource={studentsInterest}
        permissionsBasic={'fri-jobs-interests'}
        customSettings={customSettings}
      />

      <QuestionModal
        chosenPositive={() => {
          deleteInterest(rowToBeDeleted);
          setRowToBeDeleted(null);
        }}
        question={t('Naozaj sa chcete zrušiť svoj záujem o pracovnú ponuku?')}
        visible={rowToBeDeleted !== null}
        yes={t('Áno')}
        toggle={() => setRowToBeDeleted(null)}
        headerTitle={t('Zrušiť záujem o pracovnú ponuku')}
      />
    </>
  );
};

FjMyInterestsTable.propTypes = {
  studentsInterest: PropTypes.array,
  refetch: PropTypes.func,
  onEditClick: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default FjMyInterestsTable;
